import { createFeatureSelector, createSelector } from '@ngrx/store';
import { ServiceState } from './service.state';

export const selectService = createFeatureSelector<ServiceState>('service');
